// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IGSL5","option":"styles_option__3gs7c","selected":"styles_selected__295hn"};